function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { makeStyles } from '@material-ui/core/styles';
import colors from "../../foundations/colors.module.scss";
import typography from "../../foundations/typography.module.scss";
import { menuStyles } from "../Menu/Menu.styles";
export const skinToColor = {
  standard: colors.dark900,
  primary: colors.purple800
};
const baseFont = {
  fontFamily: typography.fontFamilyBold,
  fontSize: typography.fontSizeP1
};
const errorColor = colors.red950;
const disabledColor = colors.dark500;
const placeholderColor = colors.dark400;
export const useInlineSelectStyles = makeStyles({
  root: {
    width: undefined,
    '& .MuiSelect-select': {
      backgroundColor: 'transparent'
    }
  },
  inputRoot: _ref => {
    let {
      color
    } = _ref;
    return _objectSpread(_objectSpread({}, baseFont), {}, {
      color,
      // Disable input type=number arrows in Chrome, Safari, Edge, Opera
      '& input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
      },
      '&.Mui-error': {
        color: errorColor,
        '& $icon': {
          color: errorColor
        }
      },
      // Disable input type=number arrows in Firefox
      '& input[type=number]': {
        '-moz-appearance': 'textfield'
      },
      '&.Mui-error:hover': {
        color: errorColor
      },
      '&.Mui-disabled': {
        color: disabledColor
      },
      '&.MuiInput-underline': {
        '&&&:before': {
          border: 'none',
          right: '16px',
          bottom: '4px'
        },
        '&&&:hover:before': {
          borderBottom: '1px solid',
          bottom: '4px'
        },
        '&&&.Mui-error:hover:before': {
          borderBottom: '1px solid',
          borderBottomColor: errorColor,
          bottom: '4px'
        },
        '&&:after': {
          border: 'none',
          right: '16px',
          bottom: '4px'
        }
      }
    });
  },
  inputInput: _ref2 => {
    let {
      color
    } = _ref2;
    return _objectSpread(_objectSpread({}, baseFont), {}, {
      padding: 0,
      lineHeight: '24px',
      height: 22,
      '&::placeholder': _objectSpread(_objectSpread({}, baseFont), {}, {
        color
      }),
      '&:-webkit-autofill': _objectSpread(_objectSpread({}, baseFont), {}, {
        color
      }),
      '&:autofill': _objectSpread(_objectSpread({}, baseFont), {}, {
        color
      }),
      '&.MuiSelect-select': {
        lineHeight: 'var(--line-height-p1, 24px)',
        paddingRight: '16px'
      }
    });
  },
  menu: _objectSpread({
    maxHeight: props => props.menuMaxHeight,
    maxWidth: props => props.menuMaxWidth
  }, menuStyles),
  selectPlaceholder: {
    color: placeholderColor
  },
  icon: _ref3 => {
    let {
      color
    } = _ref3;
    return {
      flexShrink: 0,
      color,
      cursor: 'pointer',
      transition: 'transform 150ms ease',
      transformOrigin: '50% 50%',
      '&.MuiSelect-iconOpen': {
        transform: 'rotate(-180deg)'
      },
      position: 'absolute',
      right: 0,
      top: 4
    };
  }
});